/** Decorative chevron over a native <select>; must not steal clicks. */
const FORM_SELECT_CHEVRON_CLASS_NAME =
	"pointer-events-none absolute top-3 right-3 z-20";

export { FORM_SELECT_CHEVRON_CLASS_NAME };
